import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Product } from '@utils/product';
import { getDevice } from '@utils';
import Image from '../../base_image/component';
import Link from '../../base_link/component';
import { ProductImage } from 'audamatic-ui';
import './styles/styles.scss';
import Icon from '../../base_svg-icon/component';
import { debounce } from 'debounce';
import Shape from '@active-channel/images/shapes/spread-banner-shape.svg';


/**
 * Banner Spread component
 *
 */
class BannerSpread extends Component {
  constructor(props) {
    super(props);

    this.product = null;
    if (Array.isArray(props.products)) {
      this.setProduct(props.products[0]);
    }
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
    this.state = {
      isMobile: false,
    };
  }

  setProduct(attrs) {
    if (typeof(attrs) === 'object' && attrs) {
      this.product = new Product(attrs);
    }
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushPromotionGoogleTag(this.promotionTagData);
  }
  handleWindowResize = () => {
    const { isMobile } = getDevice();
    this.setState({ isMobile });
  };

  componentDidMount() {
    this.handleWindowResize();
    window.addEventListener('resize', debounce(this.handleWindowResize, 200));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', debounce(this.handleWindowResize, 200));
  }

  render() {
    const { title, subtitle, backgroundImage, url, colorCode, buttonText } = this.props;
    const href = url || this.product?.url || '';
    const getMobileBannerClass = () => {
      if (!this.state.isMobile) {
        return;
      }
      return  'mobileBanner';
    };

    const bannerBody =
    <div className="banner-body">
      <div className="banner-content-container">
        <p className="banner-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p>
        <h2 className="banner-title" dangerouslySetInnerHTML={{ __html: title }}></h2>
        <div className="flex-icon-container">
          <Icon name="ico-arrow-circle-right" size={150}/>
          {buttonText && <span>{buttonText}</span>}
        </div>
      </div>
    </div>;
    const renderSpreadBanner =
      <Link style={{ backgroundColor: colorCode }} href={href} className={`banner banner-spread ${getMobileBannerClass()}`} onClick={this.pushGoogleTags}>
        <div className="banner-media">
          {!!this.product && (
            <div className="banner-product">
              <div className="image wrapper product-image-wrapper">
                <ProductImage product={this.product} />
              </div>
            </div>
          )}
          {!this.state.isMobile && bannerBody}
        </div>
        <div className="banner-image" >
          {!!this.product &&
            <div className="artwork-overflow-container">
              <Shape className="artwork" />
            </div>
          }
          <div className="img-container">
            <Image src={backgroundImage} alt={title}/>
          </div>
        </div>
        {this.state.isMobile && bannerBody}
      </Link>;
    return renderSpreadBanner;
  }
}


BannerSpread.propTypes = {
  /**
   * The title which will be shown in black in the banner
   */
  title: PropTypes.string,
  /**
   * The arrow button text
   */
  buttonText: PropTypes.string,
  /**
   * The subtitle which will be shown in green in the banner
   */
  subtitle: PropTypes.string,
  /**
   * Color code for the background
   */
  colorCode: PropTypes.string,
  /**
   * Url leading to another page by clicking the banner.
   * The given url will overwrite the product url
   */
  url: PropTypes.string,
	  /**
	   * Image placed in the background
	   */
  backgroundImage: PropTypes.string,
	  /**
	   * Function that returns an object with
	   * Google Tags methods
	   */
  googleTagMethods: PropTypes.func,
  variant: PropTypes.string,
  products: PropTypes.array,
};

export default BannerSpread;
